import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { INotification, INotificationReducer, NotificationStatus } from '../../types/notifications'
import { fetchNotifications } from '../async-thunks/notifications/fetchNotifications'
import { fetchMoreNotifications } from '../async-thunks/notifications/fetchMoreNotifications'
import { markNotification } from '../async-thunks/notifications/markNotification'
import { markFilteredNotificationsRead } from '../async-thunks/notifications/markFilteredNotificationsRead'
import { markAllNotificationsRead } from '../async-thunks/notifications/markAllNotificationsRead'

const initialState: INotificationReducer = {
    notifications: [],
    hasMore: false,
    isLoading: false,
}

const notificationsSlice = createSlice({
    name: 'notificationsSlice',
    initialState,
    reducers: {
        newNotifications: (state, action: PayloadAction<any>) => {
            state.notifications.unshift(...action.payload)
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.fulfilled, (state, action: PayloadAction<{
                hasMore: boolean
                notifications: INotification[]
            } | void>) => {
                state.isLoading = false
                if (!action.payload) return
                state.hasMore = action.payload.hasMore
                state.notifications = action.payload.notifications
            })
            .addCase(fetchMoreNotifications.fulfilled, (state, action: PayloadAction<{
                hasMore: boolean
                notifications: INotification[]
            } | void>) => {
                state.isLoading = false
                if (!action.payload) return
                state.hasMore = action.payload.hasMore
                state.notifications.push(...action.payload.notifications)
            })
            .addCase(markNotification.fulfilled, (state, action: PayloadAction<{
                notificationId: string
                status: NotificationStatus
            }>) => {
                const { notificationId, status } = action.payload
                state.notifications = state.notifications.map((notification) => {
                    if (notification.notification_id === notificationId) {
                        return { ...notification, status }
                    }
                    return notification
                })
            })
            .addCase(markFilteredNotificationsRead.fulfilled, (state) => {
                state.notifications = state.notifications.map((notification) => ({
                    ...notification,
                    status: NotificationStatus.READ,
                }))
            })
            .addCase(markAllNotificationsRead.fulfilled, (state) => {
                state.notifications = state.notifications.map((notification) => ({
                    ...notification,
                    status: NotificationStatus.READ,
                }))
            })
    }
})

export const { actions: notificationsActions } = notificationsSlice
export const { reducer: notificationsReducer } = notificationsSlice
